import { Body } from '@/components/typography/body/body.component';
import { type TypographyElements } from '@/components/typography/typography.types';
import { type ComponentProps } from 'react';

type BodyProps = ComponentProps<typeof Body>;

type Props = Omit<BodyProps, 'element' | 'role'> & {
  element?: TypographyElements;
};
export const Body1 = ({ element = 'p', children, ...props }: Props) => (
  <Body variant="body1" element={element} {...props}>
    {children}
  </Body>
);

export const Body2 = ({ element = 'p', children, ...props }: Props) => (
  <Body variant="body2" element={element} {...props}>
    {children}
  </Body>
);

export const Body3 = ({ element = 'p', children, ...props }: Props) => (
  <Body variant="body3" element={element} {...props}>
    {children}
  </Body>
);

export const Body4 = ({ element = 'p', children, ...props }: Props) => (
  <Body variant="body4" element={element} {...props}>
    {children}
  </Body>
);

export const Body5 = ({ element = 'p', children, ...props }: Props) => (
  <Body variant="body5" element={element} {...props}>
    {children}
  </Body>
);
